import commonVars from "./_common.mjs";
function self() {
  return commonVars;
}
const flexLight = {
  name: 'Flex',
  self
};
export default flexLight;